class HeaderCartDropdown extends CartItems {
  constructor() {
    super();
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'cart-offcanvas-nav',
        section: 'header-cart-dropdown',
        selector: '[data-cart-content]'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-badge',
        selector: '.tm-cart-badge'
      }
    ];
  }
}

customElements.define('header-cart-dropdown', HeaderCartDropdown);
